import { Snackbar } from "@narmi/design_system";
import React from "react";
import styles from "./FloatingSnackbar.module.css";

// FloatingSnackbar is an NDS snackbar component that "floats" above the main content.
export function FloatingSnackbar(props: React.ComponentProps<typeof Snackbar>) {
  return (
    <div className={styles.FloatingSnackbar}>
      <Snackbar {...props} />
    </div>
  );
}
